const toAmount = (value) => {
  if (value == null || value === '') return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
};

export const getCheckoutPayableAmount = ({
  paymentDetails,
  orderSummary,
  quote,
  paymentMode,
  chequePrepaymentAmount,
}) => {
  const initiatedAmount = toAmount(paymentDetails?.amount);
  if (initiatedAmount != null) return initiatedAmount;

  if (paymentMode === 'cheque') {
    const prepayment = toAmount(chequePrepaymentAmount);
    if (prepayment != null) return prepayment;
  }

  const quotedAmount = toAmount(quote?.payable_amount);
  if (quotedAmount != null) return quotedAmount;

  const orderTotal = toAmount(orderSummary?.total_price_amount);
  if (orderTotal != null) {
    return Math.max(0, orderTotal - (toAmount(orderSummary?.kala_barg_amount) ?? 0));
  }

  return undefined;
};
